import {
  Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter,
  ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppState, Selectors } from 'store/root-reducer';

import { CurrentUser } from 'modules/shared/models/account.models';
import { Comment } from 'modules/shared/models/comment.models';

@Component({
  selector: 'artemis-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentComponent implements OnInit {

  @Input() set commentList(comments: Array<Comment>) {
    if (comments) {
      this._commentList = comments;
      this.cdRef.detectChanges();
    }
  }

  get commentList(): Array<Comment> {
    return this._commentList;
  }

  @Input() set subHeaderName(name: string) {
    if (name) {
      this._nameToShow = name;
      this.cdRef.detectChanges();
    }
  }

  get subHeaderName(): string {
    return this._nameToShow;
  }

  @Input() set loading(loading: boolean) {
    this._loading = loading;
    this.cdRef.detectChanges();
  }

  get loading(): boolean {
    return this._loading;
  }

  @Input() allowDeleteComment: boolean = false;

  @Output() submitNewComment: EventEmitter<string> = new EventEmitter();
  @Output() deleteComment: EventEmitter<number> = new EventEmitter();

  @ViewChild('addCommentForm', {static: false}) addCommentForm: TemplateRef<any>;

  private addCommentFormRef: MatDialogRef<TemplateRef<any>>;

  currentUser$: Observable<CurrentUser> = this.store.select(Selectors.auth.getUser);

  _nameToShow: string;
  _commentList: Array<Comment> = [];
  _loading: boolean = false;

  commentContent: string;

  constructor(private store: Store<AppState>,
              private dialog: MatDialog,
              private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  /**
   * Adds form in modal window for adding comment
   * @method openAddCommentForm
   */
  openAddCommentForm(): void {
    this.addCommentFormRef = this.dialog.open(this.addCommentForm, {
      width: '650px'
    });
  }

  /**
   * Closes modal for adding comment and clearing the text inside
   * @method closeAddCommentModal
   */
  closeAddCommentModal(): void {
    this.commentContent = '';
    this.addCommentFormRef.close();
  }

  /**
   * Submit a new comment
   * @method submitComment
   */
  emitSubmitComment(): void {
    this.submitNewComment.next(this.commentContent);
    this.closeAddCommentModal();
  }

  /**
   * Delete a comment
   * @method deleteComment
   */
  emitDeleteComment(commentId: number): void {
    this.deleteComment.next(commentId);
  }
}
